import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M16 5l-4 5 4 5V5zm-3 1H4V5h9v1zm0 9H4v-1h9v1zm-3-3H4v-1h6v1zm0-3H4V8h6v1z'],
  height: 20,
  width: 20,
});
